import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FcardBank from "../../components/FcardBank/FcardBank";
import { getBanks, deleteBankbyId } from "../../api/banks";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import { ChevronForwardOutline, Trash } from "react-ionicons";
import { useBank } from "../../hooks/useBank";
import { useHome } from "../Home/hooks/useHome";

const BankScreen = ({ param }) => {
  const route = useNavigate();
  const [loading, setloading] = useState(false);
  const [arrayBanks, setArrayBanks] = useState([]);
  const { banks, getBank, setBanks, getBankByCountry } = useBank();
  const { deleteBank } = useBank();

  useEffect(() => {
    getBank();
  }, []);

  const handleResetBankNumber = (value) => {
    return value.substr(value.length - 4);
  };


  const { isRegisteredUser
  } = useHome();


  const onDeleteClickBanks = (id) => {
    Swal.fire({
      showCloseButton: true,
      title: "Eliminar cuenta",
      text: "¿Estás seguro de eliminar la cuenta bancaria?",
      imageUrl: require("../../components/assets/images/pregunta.png"),
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Custom image",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDelete(id);
      }
    });
  };

  const confirmDelete = async (id) => {
    let resp = await deleteBank(id);
    if (resp) {
      setBanks(banks.filter(bank => bank.id != id))
    } else {
      Swal.fire({
        showCloseButton: true,
        title: "Error",
        text: "No se pudo eliminar la cuenta bancaria",
        imageUrl: require("../../components/assets/images/boton-x.png"),
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Custom image",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      });
    }
  };

  return (
    <>
      <Floading open={loading}></Floading>
      <FBannerTitleButton
        title={"Asocia tus cuentas bancarias"}
        titleButton={
          <Fbutton
            value="Agregar banco"
            onClick={() => {
              const requestNavigation = () => {
                route("/CreateBankScreen");
              };

              isRegisteredUser(requestNavigation);
            }}
          />
        }
        imageUrl={require("../../components/assets/images/bank.png")}
      />

      <FContainer>
        {banks.map((bank) => (
          <div
            className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer"
          >
            <div className="border-0 col-span-4 grid place-items-center fix relative">
            <div className="border-0 absolute w-full h-full grid justify-start pl-2">
                {bank.countryId ==  "840"? <img className="w-[25px] h-[25px]" src={require("../../components/assets/images/usa.png")} /> : null}
                {bank.countryId == "484" ? <img className="w-[25px] h-[25px]" src={require("../../components/assets/images/MX.png")} /> : null}
              </div>
              <img
                src={require("../../components/assets/images/bank-image.png")}
                className="w-full xxxs:w-[50px] xxs:w-[60px]"
                alt=""
              />
            </div>
            <div className="border-0 col-span-8 grid grid-cols-1 fix relative">
              <div className="border-0 col-span-1 text-center  font-bold text-[3.5vw] smm:text-[14px]">
                <div className="absolute w-full">{bank.countryId != "840" ? bank.bankName : bank.alias}</div>
              </div>
              <div className="border-0 mt-7 col-span-1 text-center font-bold text-Secondary text-[3.5vw] smm:text-[14px]">
                {` **** ${handleResetBankNumber(bank.accountNumber)} `}
              </div>
              <div className="border-0 absolute w-full h-full grid items-center justify-end pr-5">
                <Trash
                  height="25px"
                  width="25px"
                  color={"#E30000"}
                  onClick={() => {
                    console.log(bank.id)
                    onDeleteClickBanks(bank.id)
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </FContainer>
    </>
  );
};

export default BankScreen;
